module.exports = __webpack_public_path__ + "static/hamptonsHome2-356819cc9bc6891bb5508359e9e6137a.jpg";